import React from 'react';
import { useAbleToProvider } from '../../provider';
import styled from 'styled-components';
import { breakpoint } from '../../theme/breakpoints';
import { BREAKPOINTS, GUTTER_SIZES_MAP, MAX_COLUMNS } from '../config';
const Wrapper = styled.div`
  display: grid;
  grid-gap: ${({
  gap
}) => gap ? `${GUTTER_SIZES_MAP[gap]} !important` : `${BREAKPOINTS.mobile.gutter}`};
  grid-template-columns: repeat(${MAX_COLUMNS}, minmax(auto, 1fr));

  ${breakpoint.md`
    grid-gap: ${BREAKPOINTS.tablet.gutter};
  `}

  ${breakpoint.lg`
    grid-gap: ${BREAKPOINTS.desktop.gutter};
  `}
`;
const WrapperFlex = styled.div`
  --grid-gap: ${({
  gap
}) => gap != null ? `${GUTTER_SIZES_MAP[gap]} !important` : `${BREAKPOINTS.mobile.gutter}`};
  --grid-gap-half: calc(var(--grid-gap) * 0.5);
  --gap-compensation: calc((var(--grid-gap) * 0.5) * -1);

  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-right: var(--gap-compensation);
  margin-left: var(--gap-compensation);

  ${breakpoint.md`
    --grid-gap: ${BREAKPOINTS.tablet.gutter};
  `}

  ${breakpoint.lg`
    --grid-gap: ${BREAKPOINTS.desktop.gutter};
  `}
`;
export const Grid = ({
  children,
  gap,
  className
}) => {
  const {
    flex = false
  } = useAbleToProvider();
  const Component = flex ? WrapperFlex : Wrapper;
  return /*#__PURE__*/React.createElement(Component, {
    gap: gap,
    className: className ?? ''
  }, children);
};
export default Grid;
//# sourceMappingURL=index.js.map